import { FunctionComponent } from 'react'
import { Flyout } from '~/components/Flyout'

export const AdmRefreshHelpFlyout: FunctionComponent = () => {
  return (
    <Flyout.Content>
      <Flyout.Title>Tips & help</Flyout.Title>
      <Flyout.Body>
        <div className="[&_h2]:pt-6 [&_h2]:pb-3">
          <h2>What is a refresh rule?</h2>
          <p>It's the refresh settings to use on your stacks. A rule contains the timer between two impressions. You can define maximum impressions allowed (capping).</p>
          <h2>I don't want to refresh a bidder or a size.</h2>
          <p>In “global settings”, define which bidders and sizes will never be refreshed for all of your sites.</p>
          <h2>I don't want to refresh specific campaigns or advertisers.</h2>
          {/* The label is the one gam-manager creates, capitals included: a differently cased label is a different label. */}
          <p>In Google Ad Manager, control your demand exclusions by applying the label "Pubstack No Refresh" on the following entities:</p>
          <ul>
            <li>Advertisers</li>
            <li>Orders</li>
            <li>Line Items</li>
          </ul>
          <h2>I want to use a specific timer for a bidder.</h2>
          <p>In "global settings", you can set a timer for a bidder. It will be applied to all of your sites.</p>
          <h2>What if an impression matches several rules criteria?</h2>
          <p>The longest timer will be used, which will ensure an optimal ad experience on your website.</p>
        </div>
      </Flyout.Body>
    </Flyout.Content>
  )
}
